export enum BtnStyle {
  Primary = 'primary',
  Info = 'info',
  Light = 'light',
  Danger = 'danger',
  Warning = 'warning',
  Success = 'success'
  // others if needed
}
